import * as React from 'react';

const English = ({
  props,
  width = 24,
  height = 18,
}: {
  props?: React.SVGProps<SVGSVGElement>;
  width?: string | number;
  height?: string | number;
}) => {
  const uniqueId = React.useId();
  const clipPathId = `clip-${uniqueId}`;
  const maskBId = `mask-b-${uniqueId}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18" width={width} height={height} fill="none" {...props}>
      <g clipPath={`url(#${clipPathId})`}>
        <mask
          id={maskBId}
          width={24}
          height={18}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill="#fff"
            d="M21.714 0H2.286C1.023 0 0 1.075 0 2.4v13.2C0 16.925 1.023 18 2.286 18h19.428C22.977 18 24 16.925 24 15.6V2.4C24 1.075 22.977 0 21.714 0Z"
          />
        </mask>
        <g mask={`url(#${maskBId})`}>
          <path
            fill="#22438B"
            d="M21.714 0H2.286C1.023 0 0 1.075 0 2.4v13.2C0 16.925 1.023 18 2.286 18h19.428C22.977 18 24 16.925 24 15.6V2.4C24 1.075 22.977 0 21.714 0Z"
          />
          <path
            fill="#fff"
            fillRule="evenodd"
            d="m3.429 1.2-2.316.031.03 2.369 19.408 13.234 2.328-.045-.043-2.354L3.429 1.2Z"
            clipRule="evenodd"
          />
          <path
            fill="#C7152A"
            fillRule="evenodd"
            d="M2.287 1.2 1.145 2.4l20.571 14.4 1.143-1.2L2.287 1.2Z"
            clipRule="evenodd"
          />
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M20.571 1.2h2.286v2.4S9.428 12.475 3.449 16.834c-.072.052-2.284.003-2.284.003l-.177-2.281L20.571 1.2Z"
            clipRule="evenodd"
          />
          <path
            fill="#C7152A"
            fillRule="evenodd"
            d="M21.765 1.166 22.86 2.4 2.287 16.8l-1.142-1.2 20.62-14.434Z"
            clipRule="evenodd"
          />
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M9.145 1.2h5.714V6h8v6h-8v4.8H9.145V12h-8V6h8V1.2Z"
            clipRule="evenodd"
          />
          <path
            fill="#C7152A"
            fillRule="evenodd"
            d="M10.287 1.2h3.429v6h9.143v3.6h-9.143v6h-3.429v-6H1.145V7.2h9.142v-6Z"
            clipRule="evenodd"
          />
          <path
            stroke="#000"
            strokeOpacity={0.1}
            d="M21.713.6H2.285C1.338.6.57 1.406.57 2.4v13.2c0 .994.768 1.8 1.715 1.8h19.428c.947 0 1.714-.806 1.714-1.8V2.4c0-.994-.767-1.8-1.714-1.8Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="#fff" d="M0 0h24v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default English;
